/**
 * Корневой компонент приложения (00_GPT-RULES, 02_GPT-MODULAR).
 * Импортирует страницы из pages/, не собирает всю логику в одном файле.
 */

import { Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import LayoutWithPlank from "./components/LayoutWithPlank/LayoutWithPlank";
import Footer from "./components/Footer/Footer";
import { ChatProvider, ChatButton, ChatWindow } from "./components/Chat";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import FaqPage from "./pages/FaqPage";
import ContactPage from "./pages/ContactPage";
import ProgramPage from "./pages/ProgramPage";
import CodeRedactorPage from "./pages/CodeRedactorPage";
import AdminPanelPage from "./pages/AdminPanelPage";
import ProjectsPage from "./pages/ProjectsPage";
import DevPage from "./pages/DevPage";

/* ============================================
   АНИМИРОВАННЫЙ КОД НА ФОНЕ
   Чтобы отключить - закомментируйте следующие 2 строки:
   ============================================ */
import CodeRain from "./components/CodeRain/CodeRain";
import CursorTrail from "./components/CursorTrail/CursorTrail";

function App() {
    return (
        <ChatProvider>
            <div className="App">
                {/* АНИМИРОВАННЫЙ КОД НА ФОНЕ - чтобы отключить, закомментируйте строку ниже */}
                <CodeRain />
                {/* СЛЕД ИЗ КОДА ЗА КУРСОРОМ - чтобы отключить, закомментируйте строку ниже */}
                <CursorTrail />
                
                <Header />
                <Routes>
                    <Route path="/" element={<LayoutWithPlank />}>
                        <Route index element={<HomePage />} />
                        <Route path="services" element={<ServicesPage />} />
                        <Route path="pages" element={<FaqPage />} />
                        <Route path="contact" element={<ContactPage />} />
                        <Route path="program" element={<ProgramPage />} />
                        <Route path="code-redactor" element={<CodeRedactorPage />} />
                        <Route path="admin-panel" element={<AdminPanelPage />} />
                        <Route path="projects" element={<ProjectsPage />} />
                        <Route path="dev" element={<DevPage />} />
                    </Route>
                </Routes>
                <Footer />
                
                {/* Система онлайн чата */}
                <ChatButton />
                <ChatWindow />
            </div>
        </ChatProvider>
    );
}

export default App;
// App.js
